import styled, { css } from 'styled-components';

import theme from 'ui/theme';
import { pxToRem } from 'utils/scss';

export const IconSC = styled.div`
  font-size: ${({ size }) => pxToRem(size)};
  transform: rotate(0deg);
  color: inherit;
  color: ${({ color, disabled }) =>
    disabled ? theme().colors.fadedGray : color};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: all 250ms;

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}}

  ${({ rotate }) =>
    rotate &&
    css`
      transform: rotate(${rotate}deg);
    `};

  ${({ position, top, left, bottom, right, rotate }) =>
    position === 'absolute'
      ? css`
          position: absolute;
          top: ${pxToRem(top)};
          left: ${pxToRem(left)};
          bottom: ${pxToRem(bottom)};
          right: ${pxToRem(right)};
        `
      : position === 'center'
      ? css`
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%)
            ${rotate ? `rotate(${rotate}deg)` : ''};
        `
      : null};
`;

export const Path = styled.span``;
export const Label = styled.div`
  margin-top: ${pxToRem('5px')};
`;
export const ImgIcon = styled.img`
  filter: ${props =>
    props.hasFilter
      ? 'invert(70%) sepia(96%) saturate(2603%) hue-rotate(310deg) brightness(94%) contrast(95%) '
      : ''};
`;
